import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faBullseye, faCalendarDay, faDownload, 
  faEnvelope, faEye, faEyeSlash, faHouse, faIdBadge, 
  faIndianRupeeSign, faLink, faLock, faMoneyBillTransfer, 
  faNewspaper, faPenToSquare, faRectangleList, faShieldHalved, 
  faSquarePhone, faTicket, faTrashCan, faTrophy, faUpload, 
  faUser, faXmark } from "@fortawesome/free-solid-svg-icons";
import { faCopyright } from "@fortawesome/free-regular-svg-icons";
import { faFacebook, faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons";

const iconStyles = {
  color: "white",
  paddingRight: 10,
  fontSize: 20,
};

const barIconStyles = {
  color: "#ae0a1d",
  fontSize: 25,
};
const loginIconStyles = {
  color: "#000000",
  fontSize: 20,
};

const dashRupeeIcon = {
  color: "#000000",
  fontSize: 70,
};

const caledarIcon = {
  color: "#000000",
  fontSize: 30,
};

const trashCanIconStyle = {
  color: "#ffffff",
  fontSize: 20,
}

const downlaodIconStyle = {
  color: "red",
  fontSize: 20,
}


export const HomeIcon = () => (
  <FontAwesomeIcon
    icon={faHouse}
    style={iconStyles}
  />
);
export const RectListIcon = () => (
  <FontAwesomeIcon
    icon={faRectangleList}
    style={iconStyles}
  />
);
export const UploadIcon = () => (
  <FontAwesomeIcon
    icon={faUpload}
    style={iconStyles}
  />
);
export const MenuIcon = () => (
  <FontAwesomeIcon
    icon={faBars}
    style={barIconStyles}
  />
);
export const CloseIcon = () => (
  <FontAwesomeIcon
    icon={faXmark}
    style={iconStyles}
  />
);
export const UserIcon = () => (
  <FontAwesomeIcon
    icon={faUser}
    style={loginIconStyles}
  />
);
export const LockIcon = () => (
  <FontAwesomeIcon
    icon={faLock}
    style={loginIconStyles}
  />
);
export const EyeIcon = () => (
  <FontAwesomeIcon
    icon={faEye}
    style={loginIconStyles}
  />
);
export const EyeSlashIcon = () => (
  <FontAwesomeIcon
    icon={faEyeSlash}
    style={loginIconStyles}
  />
);
export const EditIcon = () => (
  <FontAwesomeIcon
    icon={faPenToSquare}
    style={loginIconStyles}
  />
);
export const DeleteIcon = () => (
  <FontAwesomeIcon
    icon={faTrashCan}
    style={loginIconStyles}
  />
);
export const RupeeIcon = () => (
  <FontAwesomeIcon
    icon={faIndianRupeeSign}
    style={dashRupeeIcon}
  />
);

export const TokenRupeeIcon = () => (
  <FontAwesomeIcon
    icon={faIndianRupeeSign}
    style={caledarIcon}
  />
);

export const CalendarIcon = () => (
  <FontAwesomeIcon
    icon={faCalendarDay}
    style={caledarIcon}
  />
);

export const MoneyBillIcon = () => (
  <FontAwesomeIcon
    icon={faMoneyBillTransfer}
    style={dashRupeeIcon}
  />
);

export const TikcetIcon = () => (
  <FontAwesomeIcon
    icon={faTicket}
    style={dashRupeeIcon}
  />
);

export const IdBadgeIcon = () => (
  <FontAwesomeIcon
    icon={faIdBadge}
    style={caledarIcon}
  />
);

export const TrophyIcon = () => (
  <FontAwesomeIcon
    icon={faTrophy}
    style={caledarIcon}
  />
);

export const SquarePhoneIcon = () => (
  <FontAwesomeIcon
    icon={faSquarePhone}
    style={caledarIcon}
  />
);

export const YoutubeIcon = () => (
  <FontAwesomeIcon
    icon={faLink}
    style={caledarIcon}
  />
);
export const BullsEyeIcon = () => (
  <FontAwesomeIcon
    icon={faBullseye}
    style={caledarIcon}
  />
);

export const TrashCanIcon = () => (
  <FontAwesomeIcon
    icon={faTrashCan}
    style={trashCanIconStyle}
  />
);

export const DownloadIcon = () => (
  <FontAwesomeIcon
    icon={faDownload}
    style={downlaodIconStyle}
  />
);

export const RupeeSign = () => (
  <FontAwesomeIcon
    icon={faIndianRupeeSign}
    style={{ fontSize: 15, color: "black" }} />
)

export const PpIcon = () =>(
  <FontAwesomeIcon
    icon={faShieldHalved}
    style={{ fontSize: 20, color: "white" }} />
)

export const NewsPaperIcon = () =>(
  <FontAwesomeIcon
    icon={faNewspaper}
    style={{ fontSize: 20, color: "white" }} />
)

export const MailIcon = () =>(
  <FontAwesomeIcon
    icon={faEnvelope}
    style={{ fontSize: 20, color: "white" }} />
)

export const CopyrightIcon = () =>(
  <FontAwesomeIcon
    icon={faCopyright}
    style={{ fontSize: 18, color: "white" }} />
)

export const FacebookIcon = () =>(
  <FontAwesomeIcon
    icon={faFacebook}
    style={{ fontSize: 38, color: "white" }} />
)

export const InstagramIcon = () =>(
  <FontAwesomeIcon
    icon={faInstagram}
    style={{ fontSize: 40, color: "white" }} />
)

export const YoutubeOrgIcon = () =>(
  <FontAwesomeIcon
    icon={faYoutube}
    style={{ fontSize: 40, color: "white" }} />
)

